import { Typography } from "@mui/material";

import Pill from "Components/Pill/Pill";

export const PILLS_CONFIG = [
  { key: "status", bgcolor: "#006D77", color: "#fff" },
  { key: "vehicleSegment", bgcolor: "#0033FF", color: "#fff", iconKey: "luxuryIcon", showKey: "isLuxury" },
  { key: "inspectionStatus", bgcolor: "#A26769", color: "#fff" }
];

export const renderPill = (pillConfig, value, iconSrc) => {
  if (!value) return null;

  if (pillConfig.iconKey && iconSrc) {
    return (
      <Typography
        color={pillConfig.color}
        bgcolor={pillConfig.bgcolor}
        fontSize={["1.2rem"]}
        fontWeight={500}
        lineHeight="2.4rem"
        padding="2px 1.2rem"
        borderRadius="1.6rem"
        textAlign="center"
        whiteSpace="nowrap"
        display="flex"
        alignItems="center"
      >
        <img src={iconSrc} alt={pillConfig.key} style={{ width: "16px", height: "16px", marginRight: "4px" }} />
        {value}
      </Typography>
    );
  }

  return <Pill text={value} color={pillConfig.color} bgcolor={pillConfig.bgcolor} />;
};
